import LessonLaunchParamsV2 from '../models/LessonLaunchParamsV2';
import { LessonPlayerNative } from './LessonPlayerNative';
import LessonPlayerXapi from './LessonPlayerXapi';
import LessonService from '../../shared/services/LessonService';
import React from 'react';

interface LessonPlayerEmbeddedProps {
  launchParamsV2: LessonLaunchParamsV2;
  preview: boolean;
  coursekey?: number;
  onMessage?: (event?: MessageEvent) => void;
  onCourseUpdate?: () => void;
  onClose: () => void;
  onContinueNextLesson?: (lessonCompleted: boolean) => void;
}

const LessonPlayerEmbedded = (props: LessonPlayerEmbeddedProps) => {
  const { preview, onClose, onContinueNextLesson } = props;
  return LessonService.isNative(props.launchParamsV2.lessonType) ? (
    <LessonPlayerNative
      key={props.launchParamsV2.lessonkey}
      open
      preview={preview}
      coursekey={props.coursekey}
      launchParamsV2={props.launchParamsV2}
      onCourseUpdate={props.onCourseUpdate}
      onClose={onClose}
      onContinueNextLesson={onContinueNextLesson}
    />
  ) : (
    <LessonPlayerXapi
      launchParamsV2={props.launchParamsV2}
      preview={preview}
      onMessage={props.onMessage}
    />
  );
};

export default LessonPlayerEmbedded;
